import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import {MessageBox} from 'element-ui'
import { showLoading, hideLoading } from '../utils/loading';

// import { getToken } from '../utils/auth.js'
// import { md5 } from '../utils/common.js'
import router from '../router/index'
// import store from '../store/index';
// import HyrToast from 'components/HyrToast'
Vue.use(VueAxios, axios)
const hyraxios = {
  instance: null,

  // 初始化axios实例
  init: function () {
    if (this.instance) return

    const instance = axios.create({
      timeout: 60000,
      withCredentials: true,

    })
  
    // 添加请求拦截器
    instance.interceptors.request.use(
     config => {
        try {
          const path = config.url
          const v = '1.0.0'
          const appid ='h5'
          const appsecret = process.env.ONLINE==='true'?'P%9vbr*1$0y8EFJi$CT%*a3N0Ev3dT':'123456'   
          const t = Math.round(Date.now()/1000)
          const ver ='1.1'
          const clientinfo='h5'
          const clientversion='1.0'
          const token = localStorage.getItem('reToken')
          const tosessionkey= localStorage.getItem('reSESSIONKEY')
          const cityMerchantId = localStorage.getItem('cityMerchantId')
          const requestbody = config.data
         
          const signRule = path+"|"+v+"|"+appid+"|"+appsecret+"|"+t+"|"+token+"|"+clientinfo+"|"+clientversion+"|"+requestbody
        //  const signRule = path+"|"+v+"|"+appid+"|"+appsecret+"|"+t+"|"+clientinfo+"|"+clientversion+"|"+requestbody
        //  const sign = md5(signRule)
        
          // config.headers['x-v'] = v
          // config.headers['x-appid'] = appid
          // config.headers['x-t'] = t
          // config.headers['x-ver'] = ver
          // config.headers['x-client-info'] = clientinfo
          // config.headers['x-client-version'] = clientversion
          // config.headers['x-sign'] = sign
           config.headers['SECRET'] = token
           config.headers['SESSIONKEY'] = tosessionkey
           config.headers['merchantId'] = cityMerchantId
          //  if (localStorage.getItem('channel') != '') {
          //    config.headers['channel'] = localStorage.getItem('channel')
          //  }
          return config
				}catch (err) {
					return Promise.reject(err)
				}
    }, error => {
   
      return Promise.reject(error)
    })

    // response的拦截器，在此进行错误处理，并返回data以方便使用
    instance.interceptors.response.use(
      response => {
    
        hideLoading()//关闭加载
        console.log(response, '响应拦截正式环境==')

        const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
        if (data.code == '401') { // 登录失效||未登录
      
          router.push({
            path: '/user/login',
           // query: {redirect: store.state.route.name}
          })
        
          return
        }
        if (data.code == '400') { //参数错误/处理失败/接口校验失败
         
          return data
        }

        if (data.code == '200') { //正常
          
          return data
        }
        if (data.code == '500' || data.code == '502' || data.code == '503' || data.code == '504' || data.code == '408') { //服务器错误
          window.location.href = `https://notice.kangou.cn/index.html?time=${new Date().getTime()}`
          // router.push({
          //   path: '/error500'
          // })
        }

        else {
          return data
        }
      }, function (error) {
        if (error instanceof axios.Cancel) {
          error.isCanceled = true
        } else {
          error.isCanceled = false
    
        }
       // HyrToast("网络连接失败,请检查网络")
        return Promise.reject(error)
    })

    this.instance = instance
  },

  get: function (apiName, opts) {
    // if(opts && opts.img=='img'){
    //   return this.instance.request({
    //     url: apiName,
    //     baseURL: '',
    //     //data:qs.stringify(data),
    //     method:'get',
    //     responseType: 'blob',   //这里是声明期望返回的数据类型，为blob
    //     headers: {
    //       'Content-Type': 'application/json;charset=UTF-8',
    //       //'Content-Type': 'application/x-www-form-urlencoded'
    //     },
    //   })
    // }
    console.log(apiName, '==get请求==', opts)

    if (opts && typeof opts === 'object') {
      opts = { data: opts }
    }
    
    
    return hyraxios.request(apiName, opts, 'get')
  },

  post: function (apiName, opts) {
    console.log(apiName, '==post请求==', opts)
    if (opts && typeof opts === 'object') {
      opts = { data: opts }
		}
	
    return hyraxios.request(apiName, opts, 'post')
  },

  request: function (apiName, opts, method) {
    
    this.init()
    //时时检测二维码信息，不需要显示加载浮层
    // if(apiName=="/api/user/card/cardgetofflineqrinfo"){
    if(apiName=="/apis/user/card/cardgetofflineqrinfo"){

    }
    else{
      showLoading()//显示加载中
    }
    
    
    if (typeof apiName === 'object') {
      opts = apiName
      apiName = opts.apiName
      
    } else if (typeof apiName === 'string') {
     
      if (typeof opts === 'object') {
				opts = { data: opts.data, params: opts.params }
      } else {
        opts = {data: {}, params: {}}
      }
    } else {
      throw new Error('hxaios的参数不正确')
    }
    if (!apiName) {
      throw new Error('apiName is not defined!')
    }

		const {data, params, ...rest} = opts

    return this.instance.request({
      url: apiName,
      baseURL: '',
      data: data.info === 'object' ? JSON.stringify(data.info) : data.info,
			//data:qs.stringify(data),
      method: method,
      responseType: data.info == 'img' ? 'blob' : 'json',   //这里是声明期望返回的数据类型，为blob
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        //'Content-Type': 'application/x-www-form-urlencoded'
      },
      params,
      ...rest
    })
  },
}

export default {
  get: hyraxios.get,
  post: hyraxios.post
}



// WEBPACK FOOTER //
// ./src/api/hyraxios.js